import { HASHTAG_OPTIONS } from './constants/hashtags';

export const CATEGORY_TITLES = {
  newest: 'Newest Videos',
  forsleep: '#forsleep',
  satisfying: '#satisfying',
  tingles: '#tingles',
  firstasmr: '#first ASMR Video',
  lofi: '#lofi'
};

export const INITIAL_VISIBLE_COUNT = 4;
export const LOAD_MORE_COUNT = 4;
export const ROTATION_INTERVAL_MS = 60000;

export { HASHTAG_OPTIONS };

// Chunked cache manifest (new system — try first)
export const MANIFEST_URL = 'script/cache/manifest.json';

// Existing endpoints (fallback chain)
export const API_URL = 'api/videos.php?category=all';
export const FALLBACK_URLS = ['script/cached_videos.json', 'cached_videos.json'];

// Public read-only endpoint for admin-set video flags and channel blocks
export const PUBLIC_FLAGS_URL = 'api/public-flags.php';

// Public read-only endpoint for curated Amazon gear products
export const PUBLIC_GEAR_URL = 'api/public-gear.php';

export const DEFAULT_FALLBACK_VIDEO = {
  id: "EN_eXAzQnME",
  snippet: {
    title: "ASMR You're Saying That Wrong! [Commonly Mispronounced Words]",
    channelTitle: "Jettison Dean",
    description: "I'm very guilty of this, so absolutely no judgement in this video; only pleasant tingles :)\nWishing you plentiful tingles and a good night's rest.\nMy channel updates every Monday and Thursday at 10 PM central standard time.",
  },
};
